import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'datetime',
  version: '1.2.0',
  properties: [
    {
      key: 'operation',
      label: 'Operation',
      type: 'options',
      required: true,
      default: 'now',
      options: [
        { value: 'now', name: 'Current Date/Time' },
        { value: 'format', name: 'Format Date/Time' },
        { value: 'parse', name: 'Parse String to Date' },
        { value: 'add', name: 'Add to Date/Time' },
        { value: 'subtract', name: 'Subtract from Date/Time' },
        { value: 'diff', name: 'Difference Between Dates' },
      ],
      description: 'The date/time operation to perform',
    },
    // Format operation fields
    {
      key: 'dateTime',
      label: 'Date/Time',
      type: 'string',
      required: false,
      placeholder: 'e.g., {{ $node["Previous"].output.date }} or leave empty for now',
      description: 'The date/time value to work with (leave empty to use current time)',
      displayOptions: {
        show: {
          operation: ['format', 'add', 'subtract'],
        },
      },
    },
    {
      key: 'format',
      label: 'Format',
      type: 'string',
      required: false,
      default: 'yyyy-MM-dd HH:mm:ss',
      placeholder: 'e.g., yyyy-MM-dd HH:mm:ss',
      description: 'The output format (e.g., yyyy-MM-dd, HH:mm:ss, dd/MM/yyyy)',
      displayOptions: {
        show: {
          operation: ['format'],
        },
      },
    },
    // Parse operation fields
    {
      key: 'input',
      label: 'Input String',
      type: 'string',
      required: true,
      placeholder: 'e.g., 2024-01-15 14:30:00',
      description: 'The date/time string to parse',
      displayOptions: {
        show: {
          operation: ['parse'],
        },
      },
    },
    // Add/Subtract operation fields
    {
      key: 'value',
      label: 'Value',
      type: 'number',
      required: true,
      default: 1,
      description: 'The amount to add or subtract',
      displayOptions: {
        show: {
          operation: ['add', 'subtract'],
        },
      },
    },
    {
      key: 'unit',
      label: 'Unit',
      type: 'options',
      required: true,
      default: 'days',
      options: [
        { value: 'years', name: 'Years' },
        { value: 'months', name: 'Months' },
        { value: 'days', name: 'Days' },
        { value: 'hours', name: 'Hours' },
        { value: 'minutes', name: 'Minutes' },
        { value: 'seconds', name: 'Seconds' },
      ],
      description: 'The time unit',
      displayOptions: {
        show: {
          operation: ['add', 'subtract', 'diff'],
        },
      },
    },
    // Diff operation fields
    {
      key: 'start',
      label: 'Start Date',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Previous"].output.startDate }}',
      description: 'The start date for comparison',
      displayOptions: {
        show: {
          operation: ['diff'],
        },
      },
    },
    {
      key: 'end',
      label: 'End Date',
      type: 'string',
      required: true,
      placeholder: 'e.g., {{ $node["Previous"].output.endDate }}',
      description: 'The end date for comparison',
      displayOptions: {
        show: {
          operation: ['diff'],
        },
      },
    },
  ],
};

export default schema;
